import { jsx as _jsx } from "react/jsx-runtime";
import styles from './NavItemLine.module.scss';
const NavItemLine = () => {
    return _jsx("span", { className: styles.element });
};
export default NavItemLine;
